import React from 'react';
import { ThermometerSnowflake, Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-muted/50 border-t" data-id="element-136">
      <div className="container mx-auto px-4 py-12 md:px-6 lg:py-16" data-id="element-137">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-138">
          {/* Company Info */}
          <div className="space-y-4" data-id="element-139">
            <div className="flex items-center gap-2" data-id="element-140">
              <ThermometerSnowflake className="h-6 w-6 text-primary" data-id="element-141" />
              <span className="text-lg font-bold" data-id="element-142">
                Sunflow Heated Driveways
              </span>
            </div>
            <p className="text-sm text-muted-foreground" data-id="element-143">
              Professional heated driveway installation and outdoor heating
              systems across Ontario. Keep your home safe and accessible all
              winter long.
            </p>
            <div className="flex gap-4" data-id="element-144">
              <a href="https://www.facebook.com/hellosunflow" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary" data-id="element-145">
                <Facebook className="h-5 w-5" data-id="element-146" />
                <span className="sr-only" data-id="element-147">Facebook</span>
              </a>
              <a href="https://www.instagram.com/sunflowsolarandroofing/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary" data-id="element-148">
                <Instagram className="h-5 w-5" data-id="element-149" />
                <span className="sr-only" data-id="element-150">Instagram</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-151">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-152">
              Services
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-153">
              <li data-id="element-154">Heated Driveways</li>
              <li data-id="element-155">Heated Walkways</li>
              <li data-id="element-156">Patio Heating</li>
              <li data-id="element-157">Snow Melting Systems</li>
              <li data-id="element-158">System Maintenance</li>
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-159">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-160">
              Service Areas
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-161">
              <li data-id="element-162">Toronto & GTA</li>
              <li data-id="element-163">Ottawa</li>
              <li data-id="element-164">Hamilton</li>
              <li data-id="element-165">London</li>
              <li data-id="element-166">Barrie & Simcoe</li>
              <li data-id="element-167">All of Ontario</li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-168">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-169">
              Contact Us
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-170">
              <li className="flex items-start gap-2" data-id="element-171">
                <MapPin className="h-5 w-5 shrink-0 text-primary" data-id="element-172" />
                <span data-id="element-173">30 Quarry Ridge Rd, Barrie, ON L4M 7G1</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-174">
                <Phone className="h-5 w-5 shrink-0 text-primary" data-id="element-175" />
                <a href="tel:647-706-9908" className="hover:text-primary" data-id="element-176">
                  (647) 706-9908
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-177">
                <Mail className="h-5 w-5 shrink-0 text-primary" data-id="element-178" />
                <a href="mailto:info@sunflow.ca" className="hover:text-primary" data-id="element-179">
                  info@sunflow.ca
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t pt-8 text-center text-sm text-muted-foreground" data-id="element-180">
          <p data-id="element-181">
            &copy; {new Date().getFullYear()} Sunflow Heated Driveways. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}